import * as React from "react"
import Svg, { Path } from "react-native-svg"
import { ColorValue, StyleProp, ViewStyle } from 'react-native'

interface Props {
    style?: StyleProp<ViewStyle>
    size?: number
    fill?: String | ColorValue;
    bg?: String | ColorValue;
}

function SvgComponent(props: Props) {
  return (
    <Svg width={props.size || 18} height={props.size || 18} viewBox="0 0 26 27" style={[props.style]}>
      <Path fill={props.bg ? (typeof props.bg === 'string' ? props.bg : String(props.bg)) : 'transparent'} fillOpacity={1} d="M.625 1h25v25h-25z" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.15 4.586a.983.983 0 011.414 0l7.293 7.3 7.293-7.3a.983.983 0 011.414 0c.391.4.391 1 0 1.4l-7.293 7.3 7.293 7.3c.391.4.391 1 0 1.4-.39.4-1.024.4-1.414 0l-7.293-7.3-7.293 7.3c-.39.4-1.024.4-1.414 0a.983.983 0 010-1.4l7.293-7.3-7.293-7.3a.983.983 0 010-1.4z"
        fill={props.fill ? (typeof props.fill === 'string' ? props.fill : String(props.fill)) : '#5885FB'}
      />
    </Svg>
  )
}

export default SvgComponent